"use client";

import Link from 'next/link';
import { useState } from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-gray-800 p-4">
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-white text-2xl font-bold">
                    Reddo
                </div>

                {/* Hamburger Menu for Mobile */}
                <div className="block lg:hidden">
                    <button onClick={() => setIsOpen(!isOpen)} className="text-white focus:outline-none">
                        {isOpen ? (
                            <XMarkIcon className="h-6 w-6" />
                        ) : (
                            <Bars3Icon className="h-6 w-6" />
                        )}
                    </button>
                </div>

                {/* Desktop Menu */}
                <ul className={`lg:flex space-x-6 items-center ${isOpen ? 'block' : 'hidden'} lg:block`}>
                    <li className="my-2 lg:my-0">
                        <div className="flex items-center space-x-2">
                            <input
                                type="text"
                                placeholder="搜索产品,电影,新闻..."
                                className="p-1 pl-4 rounded-md text-gray-800 w-48"
                            />
                        </div>
                    </li>
                    <li className="my-2 lg:my-0">
                        <Link href="/" className="text-white hover:text-red-500">
                            首页
                        </Link>
                    </li>
                    <li className="my-2 lg:my-0">
                        <Link href="/analyse_home" className="text-white hover:text-red-500">
                            产品
                        </Link>
                    </li>
                    <li className="my-2 lg:my-0">
                        <Link href="/news_home" className="text-white hover:text-red-500">
                            新闻
                        </Link>
                    </li>
                    <li className="my-2 lg:my-0">
                        <Link
                            href="https://remotely.feishu.cn/docx/VJHPdvzGSoBSnNxvQL1cEcuBnPc"
                            className="text-white hover:text-red-500"
                        >
                            关于我们
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
